<div>
  <!-- Filter Input -->
  <div class="filter-container">
    <div class="filter-input" [class.has-filters]="selectedTypes.length > 0" (click)="toggleFilterDropdown()">
      <div class="filter-content">
        <div class="filter-text">{{ getFilterText() }}</div>
        <div class="filter-icon">
          <img
            src="assets/img/chevron-down.svg"
            class="chevron-down"
            [ngClass]="{ rotated: showFilterDropdown }"
            alt="chevron down" />
        </div>
      </div>
    </div>

    <!-- Filter Dropdown -->
    <div>
      <div
        class="filter-dropdown"
        [class.has-filters]="selectedTypes.length > 0"
        *ngIf="showFilterDropdown"
        (click)="$event.stopPropagation()">
        <div class="dropdown-option" *ngFor="let type of noteTypes" (click)="toggleNoteType(type.type)">
          <div class="checkbox-container">
            <div class="checkbox" [class.checked]="selectedTypes.includes(type.type)">
              <div class="checkbox-inner" *ngIf="selectedTypes.includes(type.type)"></div>
            </div>
          </div>
          <div class="option-text">{{ type.label }}</div>
        </div>
      </div>

      <!-- Clear Button -->
      <div *ngIf="selectedTypes.length > 0" (click)="clearFilter()">
        <div class="clear-text">Clear</div>
      </div>
    </div>
  </div>

  <!-- Notes Container -->
  <div class="notes-container">
    <ng-container *ngIf="filteredNotes.length > 0">
      <div class="note-card" *ngFor="let note of filteredNotes">
        <!-- Note Header -->
        <div class="note-header">
          <div class="note-author">
            <div class="author-name">
              {{ getUserDisplayName(note.user) }}
            </div>
          </div>
          <div class="note-type-badge" *ngIf="note.type">
            <div class="badge-text">{{ getNoteTypeLabel(note.type) }}</div>
          </div>
        </div>

        <!-- Divider -->
        <div class="note-divider"></div>

        <!-- Note Metadata -->
        <div class="note-metadata">
          <div class="metadata-item">
            <img src="assets/img/calendar.svg" class="metadata-icon" alt="calendar" />
            <div class="metadata-text">{{ formatDate(note.date) }}</div>
          </div>
          <div class="metadata-item">
            <img src="assets/img/time.svg" class="metadata-icon" alt="time" />
            <div class="metadata-text">{{ formatTime(note.date) }}</div>
          </div>
          <div class="metadata-item">
            <img src="assets/img/appointment.svg" class="metadata-icon" alt="appointment" />
            <div class="metadata-text">
              {{ getTruncatedMetadataText(note.type == 'scheduling' ? note.reason : note.type) }}
            </div>
          </div>
        </div>

        <!-- Note Content -->
        <div class="note-content">
          {{ isExpanded(note) ? note.note : getTruncatedText(note.note) }}
        </div>

        <!-- Note Footer -->
        <div class="note-footer">
          <div class="note-tag">
            <img
              [src]="getTagIconSrc(getNoteTypeValue(note.user))"
              class="tag-icon"
              [alt]="getNoteTypeLabel(note.type)" />
            <div class="tag-text" [ngClass]="getTagTextClass(getNoteTypeValue(note.user))">
              {{ getTagText(getNoteTypeValue(note.user)) }}
            </div>
          </div>
          <div class="read-more-button" *ngIf="shouldShowReadMore(note.note)" (click)="toggleNoteExpansion(note)">
            <div class="button-text">{{ isExpanded(note) ? 'Read Less' : 'Read More' }}</div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="filteredNotes.length === 0 && selectedTypes.length > 0">
      <div class="empty-state-container">
        <div class="empty-state-title">No results found</div>
        <div class="empty-state-subtitle">Try adjusting your filters or search terms.</div>
      </div>
    </div>
    <div class="empty-state" *ngIf="filteredNotes.length === 0 && selectedTypes.length == 0">
      <div class="empty-state-container">
        <div class="empty-state-title">No Notes Yet!</div>
      </div>
    </div>
  </div>
</div>
